import React from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { colors } from "@mui/material";

interface BarChartProps {
  tasks: {
    name: string;
    data: number[];
  }[];
  categories: string[];
  onTimeRangeChange?: (range: '5D' | '2W' | '1M' | '6M' | '1Y') => void;
  currentTimeRange?: string;
}

const BarChart: React.FC<BarChartProps> = ({ tasks, categories, onTimeRangeChange, currentTimeRange = '1M',}) => {
  const state = {
    series: tasks,
    options: {
      chart: {
        type: "bar" as const,
        height: 350,
        toolbar: {
          show: false // This hides the toolbar
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 0,
          // borderRadiusApplication: "end",
          dataLabels: {
            total: {
              enabled: true,
              style: {
                fontSize: '16px',
                fontWeight: 900,
              },
            }
          }
        },
      },

      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: categories,
        labels: {
          style: {
            colors: '#525866',
            fontSize: '12px',
          },
        },
        axisBorder: {
          show: true,
          color: '#E2E4E9',
        },
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        tickAmount: 4,
        labels: {
          style: {
            colors: ['#525866'],
            fontSize: '12px',
          },
          formatter: function (val: number) {
            return `${Math.round(val)}`;
          },
        },
      },
      colors: ["#8979FF", "#FF928A", "#3CC3DF"],

      fill: {
        opacity: 1,
      },
      grid: {
        borderColor: "#ddd",
        strokeDashArray: 4,
        column: {
          colors: ["#D6DBED66", "transparent"],
        },
      },
    },
  };

  return (
    <div>
      <div className="toolbar area-chart-toolbar" style={{ marginBottom: '1rem' }}>
        {['5D', '2W', '1M', '6M', '1Y'].map((range) => (
          <button
            key={range}
            onClick={() => onTimeRangeChange?.(range as '5D' | '2W' | '1M' | '6M' | '1Y')}
            className={currentTimeRange === range ? 'active' : ''}
          >
            {range}
          </button>
        ))}
      </div>
      <div id="chart1">
        <ReactApexChart
          options={state.options}
          series={state.series}
          type="bar"
          height={350}
        />
      </div>
    </div>
  );
};

export default BarChart;
